import LegalPage from "@/pages/LegalPage";
import { BRAND } from "@/lib/constants";

export default function Privacy() {
  return (
    <LegalPage
      overline="Persondatapolitik"
      title="Privatlivspolitik"
      sections={[
        {
          heading: "1. Dataansvarlig",
          body: [
            `${BRAND.legalName} (CVR ${BRAND.cvr}), ${BRAND.address.street}, ${BRAND.address.city}, er dataansvarlig for de personoplysninger, der behandles gennem gudiksenstays.dk.`,
            `Har du spørgsmål til vores behandling af dine oplysninger, kan du kontakte os på ${BRAND.email} eller ${BRAND.phone}.`,
          ],
        },
        {
          heading: "2. Hvilke oplysninger indsamler vi?",
          body: [
            "Vi behandler kun de oplysninger, du selv giver os, samt tekniske data der er nødvendige for at drive siden. Konkret behandler vi:",
            [
              "Kontaktoplysninger: navn, e-mail, telefonnummer og eventuelt boligtype, når du udfylder en formular.",
              "Beskeder du sender via kontaktformularen eller booking-formularen.",
              "Tekniske oplysninger: IP-adresse, browsertype, sprog og enhedstype (kun i anonymiseret form).",
              "Cookie-relaterede oplysninger, hvis du samtykker til statistik-cookies (se cookiepolitik).",
            ],
          ],
        },
        {
          heading: "3. Formål og retsgrundlag",
          body: [
            "Vi behandler dine oplysninger til følgende formål:",
            [
              "At besvare din henvendelse og indgå/administrere en aftale (retsgrundlag: databeskyttelsesforordningens art. 6, stk. 1, litra b).",
              "At overholde retlige forpligtelser, fx bogføringslovens krav (art. 6, stk. 1, litra c).",
              "At forbedre siden gennem anonym statistik, hvis du har samtykket til dette (art. 6, stk. 1, litra a).",
            ],
          ],
        },
        {
          heading: "4. Hvem videregiver vi oplysninger til?",
          body: [
            "Vi videregiver kun dine oplysninger, når det er nødvendigt for at levere vores service, eller når vi er retligt forpligtet til det.",
            "Vi bruger følgende databehandlere, som alle er underlagt databehandleraftale:",
            [
              "Resend (e-mail-udbyder, EU/USA – Standard Contractual Clauses).",
              "MongoDB Atlas / hosting-udbyder til opbevaring af formularhenvendelser.",
              "Calendly (kalenderbooking) – hvis du selv vælger at booke et møde.",
            ],
          ],
        },
        {
          heading: "5. Opbevaring og sletning",
          body: [
            "Kontaktformular-henvendelser opbevares så længe det er relevant for dialogen med dig, og slettes senest 3 år efter sidste kontakt, med mindre andet følger af bogføringslovens 5-års krav (fx ved indgået aftale).",
            "Regnskabsmateriale opbevares i 5 år som lovpligtigt.",
          ],
        },
        {
          heading: "6. Dine rettigheder",
          body: [
            "Du har efter databeskyttelsesforordningen ret til:",
            [
              "Indsigt i, hvilke oplysninger vi behandler om dig.",
              "Berigtigelse af urigtige oplysninger.",
              "Sletning af oplysninger (retten til at blive glemt), inden for lovens rammer.",
              "Begrænsning af behandlingen.",
              "Dataportabilitet.",
              "Indsigelse mod behandlingen.",
              "Tilbagetrækning af samtykke (gælder cookies m.v.).",
            ],
            `For at udøve dine rettigheder, skriv til ${BRAND.email}. Du har også ret til at klage til Datatilsynet (datatilsynet.dk).`,
          ],
        },
        {
          heading: "7. Sikkerhed",
          body: [
            "Vi har truffet passende tekniske og organisatoriske foranstaltninger for at beskytte dine oplysninger mod uautoriseret adgang, tab og misbrug. Adgang til data er begrænset til personer, der har et sagligt behov.",
          ],
        },
        {
          heading: "8. Ændringer i politikken",
          body: [
            "Vi kan opdatere denne privatlivspolitik løbende. Den til enhver tid gældende version findes altid på gudiksenstays.dk/privatlivspolitik.",
          ],
        },
      ]}
    />
  );
}
